var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEnvironment({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#C4FFC6"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_502_9)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.2658 10.7263C29.0054 10.4665 28.6905 10.2676 28.344 10.1442C27.9974 10.0207 27.6278 9.97558 27.2617 10.0122C24.9342 10.2372 17.1067 11.2063 14.0834 14.2263C12.6382 15.6755 11.7812 17.6087 11.6779 19.6527C11.5747 21.6967 12.2324 23.7064 13.5242 25.2938L10.2409 28.5772C10.0891 28.7343 10.0051 28.9448 10.007 29.1633C10.0089 29.3818 10.0965 29.5908 10.251 29.7453C10.4055 29.8998 10.6145 29.9875 10.833 29.9894C11.0515 29.9913 11.262 29.9073 11.4192 29.7555L14.7025 26.4722C16.2896 27.7657 18.2999 28.4248 20.3448 28.3221C22.3896 28.2195 24.3238 27.3623 25.7734 25.9163C28.8367 22.8522 29.7733 15.0488 29.9892 12.7305C30.0245 12.3637 29.9779 11.9937 29.8528 11.6471C29.7277 11.3005 29.5272 10.986 29.2658 10.7263V10.7263ZM24.5992 24.7347C23.4629 25.8667 21.9535 26.5466 20.3528 26.6474C18.752 26.7481 17.1692 26.2628 15.9 25.2822L23.9267 17.2555C24.0785 17.0983 24.1625 16.8878 24.1606 16.6693C24.1587 16.4508 24.071 16.2418 23.9165 16.0873C23.762 15.9328 23.553 15.8452 23.3345 15.8433C23.116 15.8414 22.9055 15.9254 22.7484 16.0772L14.7175 24.1038C13.7367 22.8347 13.2513 21.2519 13.3521 19.6511C13.4528 18.0502 14.1328 16.5408 15.265 15.4047C17.3559 13.3147 23.1209 12.083 27.4225 11.6705C27.5444 11.6586 27.6673 11.6738 27.7826 11.7148C27.8979 11.7558 28.0028 11.8218 28.0898 11.9079C28.1767 11.9941 28.2436 12.0984 28.2857 12.2133C28.3278 12.3282 28.3441 12.4511 28.3333 12.573C27.9167 17.0622 26.7159 22.6138 24.595 24.7347H24.5992Z",
    fill: "#025D00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_502_9"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(10 10)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEnvironment);
export default __webpack_public_path__ + "static/media/environment.fdb2a2ea285a39eb95a2ff1902cce637.svg";
export { ForwardRef as ReactComponent };